import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { EkpayUser } from '../user/ekpay_user';
import { ServiceResponse } from '../payment/services/service-response';

@Injectable()
export class DataStorageService {
  public ekpay_id:string;
  ekpayData=new BehaviorSubject<string>(this.ekpay_id);
  ekpayId$=this.ekpayData.asObservable();

  public storage: any;
  public isDataAvailable: boolean;
  public user:EkpayUser;
  userDataService=new BehaviorSubject<EkpayUser>(this.user);
  
  dataSource = new BehaviorSubject<boolean>(this.isDataAvailable);
 
  userData$=this.userDataService.asObservable();
  
  dataAvail = this.dataSource.asObservable()
  
  public lang:string;
  langData=new BehaviorSubject<string>(this.lang);
  langData$=this.langData.asObservable();
  
  public serResp:ServiceResponse;
  servResp=new BehaviorSubject<ServiceResponse>(this.serResp);
  servResp$=this.servResp.asObservable();
  
  constructor() { }
  get isEmpty(): boolean {
    return this.storage === null || this.storage === undefined;
  }

    
  setServResp(serv:ServiceResponse){
    this.servResp.next(serv);
  }

  setUserData(user:EkpayUser){
    this.userDataService.next(user);
  }
  setekpayid(ekpayId:string){
    console.log('ekpayId>>>>>>>'+JSON.stringify(ekpayId));
    this.ekpayData.next(ekpayId);
  }
   
  setLangData(Lang:string){
    this.langData.next(Lang);
  }
  
}


// WEBPACK FOOTER //
// ./src/app/shared/data-storage.service.ts